<template>
  <span><sup class="dollar-sign">$</sup><span>{{currencyValue}}</span></span>
</template>

<script>
export default {
  props: {
    value: Number,
    decimals: {
      type: Number,
      default: 2,
    },
  },

  computed: {
    currencyValue() {
      const result = (Math.round(this.value * 100) / 100).toFixed(this.decimals);
      if (result === 'NaN') return 'N/A';
      if (result && result.length > 6) {
        return new Intl.NumberFormat('en-US', { style: 'decimal', currency: 'USD' }).format(Number(result));
      }
      return result;
    },
  },
};
</script>
